module.exports = __webpack_public_path__ + "img/icon_step_content01.808502fb.png";